import React, {useEffect, useRef} from 'react'
import {useHeaderContext} from '../contexts/header-context'
import {useLocation} from 'react-router-dom'

export const useStickyThreshold = () => {
    const location = useLocation()
    const {headerHeight, setShouldShowSticky} = useHeaderContext()
    const filtersRef = useRef(null)

    useEffect(() => {
        if (!filtersRef.current || headerHeight === 0) return

        const observer = new IntersectionObserver(
            ([{isIntersecting}]) => {
                setShouldShowSticky(!isIntersecting)
            },
            {
                rootMargin: `-${headerHeight}px 0px 0px 0px`,
                threshold: 0.25
            }
        )

        observer.observe(filtersRef.current)

        return () => observer.disconnect()
    }, [headerHeight, location.pathname])

    // Reset sticky on route change
    useEffect(() => {
        setShouldShowSticky(false)
    }, [location.pathname])

    return {filtersRef}
}
